import React, {useEffect} from 'react';
import {Text} from 'react-aria-components';
import {LuCog} from "react-icons/lu";
import {Navigate, useParams} from "react-router-dom";

import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout";
import {LabeledSection, LabeledTextField} from "../../components/Fields/LabeledTextField.jsx";
import DefaultButton, {SecondaryButton} from "../../components/Buttons/DefaultButton/DefaultButton";
import api from "../../utils/api";
import "./RoleEdit.css";


function RoleEdit({
    syntheticUserId = null,
    defaultName = "",
    defaultPageTitle = "Create Role",
}: {
    returnTo?: string,
    syntheticUserId?: string,
    defaultName?: string,
    defaultPageTitle?: string,
}) {
    const [submitting, setSubmitting] = React.useState(false)
    const [name, setName] = React.useState(defaultName)
    const [description, setDescription] = React.useState("")

    const [redirectTo, setRedirectTo] = React.useState(null)
    const {id} = useParams();

    async function submit() {
        setSubmitting(true)
        await api.createRole({
            name: name,
            description: description,
        }).then((result) => {
            setSubmitting(false)
            if (result) {
                setRedirectTo(`/roles`)
            }
        })
    }

    function onNameChange(e){
        setName(e.target.value)
    }

    function onDescriptionUpdate(e){
        setDescription(e.target.value)
    }

    useEffect(() => {
        if (id!==null) {
            api.listRoles().then(roles => {
                console.log(roles)
                roles.forEach(role => {
                    console.log(role);
                    if (role.id === id) {
                        setName(role.name)
                        setDescription(role.description)
                    }
                })
            })
        }
    }, []);

    if (submitting) {
        return <Text>Submitting...</Text>
    }

    if (redirectTo !== null && redirectTo !== window.location.pathname) {
        return <Navigate to={redirectTo} />
    }

    const content = <div id="role=edit">
            <LabeledSection label="General" icon={<LuCog/>} className="general-settings">
                <LabeledTextField
                    label="Name"
                    value={name}
                    placeholder="Role Name"
                    onChange={onNameChange}
                    name="name"
                    errorLoc={["body", "name"]}
                    hiddenLabel={undefined}
                />
                <div className="labeled-text-field" aria-labelledby="descriptionId">
                    <LabeledTextField
                        label="Description"
                        value={description}
                        placeholder="Role Description"
                        onChange={onDescriptionUpdate}
                        name="description"
                        errorLoc={["body", "description"]}
                        hiddenLabel={undefined}
                    />
                </div>
            </LabeledSection>

            <div className="save-row">
                <SecondaryButton
                    className="cancel-button"
                    text="Cancel"
                    href={id===null? "/roles" : `/role/${id}`} />
                <DefaultButton text="Save" onPress={submit} oneClick />
            </div>
        </div>

    return <FullWidthLayout
        title={defaultPageTitle}
        mainContent={content}
    />
}

export default RoleEdit;
